import React, { useState, useEffect, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChatContacts from "./ChatContact";
import ChatMessages from "./ChatMessage";
import ChatSendMessage from "./ChatSendMessage";
import { useQuery } from "@tanstack/react-query";
import { fetchOnlyData } from "../../utility/superAdminApi";

const ChatPopup = ({ openMessage, setOpenMessage, setTotalUnreadMessages }) => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedContactName, setSelectedContactName] = useState(null);

  const { data, refetch } = useQuery({
    queryKey: ["superAdminContacts"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("/api/superadmin/chats/contacts"),
    retry: 2,
    refetchOnMount: false, // Disable refetch on mount
    refetchOnWindowFocus: false, // Disable refetch on window focus
    // Keep previous data during page changes
  });

  const allUnread = useMemo(() => {
    if (!data || typeof data !== "object") return [];

    return Object.values(data).flatMap((company) =>
      company.users.flatMap((user) =>
        user.messages.filter(
          (msg) => Number(msg.is_read) === 0 && msg.role === "receiver"
        )
      )
    );
  }, [data]);

  useEffect(() => {
    const unreadCount = allUnread.length; // Get total unread messages count
    setTotalUnreadMessages(unreadCount);
  }, [allUnread, setTotalUnreadMessages]);

  const handleClose = () => {
    setOpenMessage(false);
    setSelectedContact(null);
  };

  const handleContactClick = (contactId, name) => {
    setSelectedContact(contactId);
    setSelectedContactName(name);
  };

  const handleRefetch = () => {
    setTimeout(() => {
      refetch();
    }, 2000);
  };

  return (
    openMessage && (
      <div className="pt-2 bg-gray-100 absolute right-2 top-16 mt-2  lg:w-[38rem] shadow-lg rounded-lg z-30  overflow-hidden">
        <div className="flex justify-end pr-2  border-b-2">
          <CancelIcon
            onClick={handleClose}
            className="cursor-pointer text-black mb-2"
          />
        </div>

        <div className=" flex h-[480px]">
          {/* Contact List */}
          <div className="w-2/6 bg-gray-100 p-3 border-r text-gray-800 border-gray-200 overflow-y-auto ">
            <h2 className="font-bold mb-4 ">Contacts</h2>
            <ChatContacts handleContactClick={handleContactClick} data={data} />
          </div>

          {/* Chat Screen */}
          <div className="w-4/6 flex bg-white flex-col">
            <div className="p-4 border-b border-gray-200">
              <h2 className="font-bold text-gray-800">
                {selectedContactName ? (
                  <div>
                    {" "}
                    <AccountCircleIcon /> {selectedContactName}
                  </div>
                ) : (
                  "Select a contact"
                )}
              </h2>
            </div>
            <ChatMessages
              selectedContact={selectedContact}
              handleRefetch={handleRefetch}
            />
            <ChatSendMessage selectedContact={selectedContact} />
          </div>
        </div>
      </div>
    )
  );
};

export default ChatPopup;
